import ReviewRegistrations from "./components/ReviewRegistrations";
import ManageDashboards from "./components/ManageDashboards";
import SingleDashboard from "./components/SingleDashboard";
import ManageUsers from "./components/ManageUsers";
import SingleUser from "./components/SingleUser";
import ManageGroupPermissions from "./components/ManageGroupPermissions";
import ManageOutages from "./components/ManageOutages";
import ManageAcrOutages from "./components/ManageAcrOutages";
import ManageAcrQueries from "./components/ManageAcrQueries";
import ManageTopChannels from "./components/ManageTopChannels";

const adminPages = [
  {
    title: "Review Registrations",
    to: "/admin/registration",
    path: "/admin/registration",
    component: ReviewRegistrations,
    icon: "applications"
  },
  {
    title: "Manage Dashboards",
    to: "/admin/dashboards",
    path: "/admin/dashboards",
    component: ManageDashboards,
    icon: "companies"
  },
  {
    path: "/admin/dashboards/:id",
    component: SingleDashboard
  },
  {
    title: "Manage Users",
    to: "/admin/users",
    path: "/admin/users",
    component: ManageUsers,
    icon: "users"
  },
  {
    path: "/admin/users/:id",
    component: SingleUser
  },
  {
    title: "Group Permissions",
    path: "/admin/group-permissions",
    to: "/admin/group-permissions",
    component: ManageGroupPermissions,
    icon: "account-settings"
  },
  {
    title: "Application Outages",
    path: "/admin/outages",
    to: "/admin/outages",
    component: ManageOutages,
    icon: "minus-o"
  },
  {
    title: "Acr Outages",
    path: "/admin/acr-outages",
    to: "/admin/acr-outages",
    component: ManageAcrOutages,
    icon: "minus-o"
  },
  {
    title: "Top Channels",
    path: "/admin/top-channels",
    to: "/admin/top-channels",
    component: ManageTopChannels,
    icon: "tv-insights"
  },
  {
    title: "ACR Queries",
    path: "/admin/acr-queries",
    to: "/admin/acr-queries",
    component: ManageAcrQueries,
    icon: "account-settings"
  }
];

export default adminPages;
